import React from 'react';
import SubSection from '../../libs/react-components-admin/section/sub-section';

const FormNoteForDevelopers = () => {

  return <SubSection title="Note for developers" className="my-3">
    You can define Javascript callbacks that will be invoked automatically by the app:<br />
    <code style={{display: 'block'}}>
      window.acerillFormBuilderOnFormLoaded = function() &#123;
      <div className="ms-2">&#47;&#47; logic goes here</div>
      &#125;;
    </code>
    <code style={{display: 'block'}}>
      window.acerillFormBuilderFormValidation = function(submission) &#123;
      <div className="ms-2">&#47;&#47; logic goes here, e.g. return &#39;Invalid field&#39;&#59;</div>
      &#125;;
    </code>
    <code style={{display: 'block'}}>
      window.acerillFormBuilderOnFormSubmitted = function(submission) &#123;
      <div className="ms-2">&#47;&#47; logic goes here, e.g. console.log(submission);</div>
      &#125;;
    </code>
  </SubSection>;
};
export default FormNoteForDevelopers;
